import styled from 'styled-components';

export const UploadImageStyled = styled.div`
  .title {
    font-style: normal;
    font-size: 14px;
    color: #0c3255;
    padding-bottom: 8px;
    .required {
      color: red;
    }
  }

  .loading {
    width: 200px;
    height: 200px;
    text-align: center;
    line-height: 200px;
  }

  .upload-wrapper {
    width: 200px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    cursor: pointer;
    border: 1px solid #d9d9d9;
  }

  .video-wrapper {
    position: relative;
    width: 300px;
    height: auto;
  }

  .ant-image-img {
    border: 1px solid #d9d9d9;
    object-fit: contain;
  }

  .ant-upload.ant-upload-select {
    position: relative;

    .btn-remove-img {
      position: absolute;
      top: -11px;
      right: -11px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      color: #fff;
      background-color: rgb(219, 44, 31);
      border-radius: 9999px;
      cursor: pointer;
    }
  }
`
